import { render, staticRenderFns } from "./QrcodeLoginPopup.vue?vue&type=template&id=31277896&scoped=true&"
import script from "./QrcodeLoginPopup.vue?vue&type=script&lang=js&"
export * from "./QrcodeLoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeLoginPopup.vue?vue&type=style&index=0&id=31277896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31277896",
  null
  
)

export default component.exports